import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import { Biller } from "model/";
import React from 'react';
import BillerInfoView from "./components/views/BillerInfoView";
import "./styles.css";
/**
 * @function BillerView 
 * @param {React.Component} checkbox - Pass the UICheckbox as a React component.
 * @param {STRING} paymentInfo - Pass the biller's payment info.
 * @param {React.Component} buttons - Pass UIButton as a React component.
 * @param {React.Component} upsell - Pass any variation of the upsell views.
 * @returns {React.Component}
 * @example
 * <BillerView checkbox={<UICheckbox />} paymentInfo={paymentInfo} buttons={<UIButton className="primary-button" />} upsell={<UpselleBillView />} />

 */

export default function BillerView(props) {
    const biller = props.biller instanceof Biller ? props.biller : Biller.initByID(props.biller ?? "0");
    
    return (
        // BillerView has to be inside of a container that has a flex-container and flex-vertical inside of the page component.
        <div>
            {/* Some places, like "Recent Activity" in the "Pay Bills" page
            will have the entire "WidgetView" component as clickable with navigation. */}
            <WidgetView className={ props.className ?? "" } onClick={ props.onClick }>
                <WidgetMainContentView>
                    {props.checkbox}
                    <div className="flex-width biller-info-view-container">
                        <BillerInfoView biller={ biller } hasBillerNameLinkClick={ props.hasBillerNameLinkClick }
                        dataPoint={ props.dataPoint }></BillerInfoView>
                    </div>
                    {/* Some payments like "MyMortgage Home Loans" don't show this payment info. */}
                    { (props.showPaymentInfo === true || props.showPaymentInfo === undefined) &&
                        <div className="set-width payment-info-view-container">
                        {props.paymentInfo}
                    </div>
                    }
                    
                    {props.buttons}
                    {/* Some payments like "MyMortgage Home Loans" don't show this payment info. */}
                    { (props.showPaymentInfoBottom === true) &&
                        <div className="set-width payment-info-view-container payment-info-view-container-bottom">
                            {props.bottomPaymentInfo}
                        </div>
                    }
                    {/* Any variation of the upsell can be placed here */}
                    {props.upsell}
                </WidgetMainContentView>
            </WidgetView>
        </div>
    );
  }